import React, { FC, useMemo } from 'react';

import { FormattedMessage } from 'react-intl';
import { useSearchParams } from 'react-router-dom';

import { SectionHeader } from '../../styles';
import { LandingGame } from '../../types';

import GoalsByPeriod from './components/goalsByPeriod/GoalsByPeriod';

import { PeriodContainer, ScoringSummaryContainer } from './styles';

type Props = {
    isLarge: boolean;
    game: LandingGame;
};

const ScoringSummary: FC<Props> = ({ isLarge, game }) => {
    const [searchParams] = useSearchParams();

    const periodScoring = useMemo(
        () =>
            game.summary?.scoring?.filter((period) => {
                if (game.shootoutInUse && period.periodDescriptor.number === game.maxPeriods) return false;
                return period.goals.length > 0;
            }) || [],
        [game.maxPeriods, game.summary?.scoring, game.shootoutInUse]
    );

    return periodScoring.length > 0 || game.summary.shootout ? (
        <ScoringSummaryContainer>
            <SectionHeader aria-level={2}>
                <FormattedMessage
                    description="A word describing the details of a goal. (Goal scorer, period, time, who assisted them)"
                    defaultMessage="Scoring"
                />
            </SectionHeader>
            {periodScoring.map((scoringPeriod) => (
                <PeriodContainer key={scoringPeriod.periodDescriptor.number}>
                    <GoalsByPeriod
                        game={game}
                        scoring={scoringPeriod}
                        isLarge={isLarge}
                        isWebView={searchParams.has('wv') && searchParams.get('wv') === 'true'}
                    />
                </PeriodContainer>
            ))}
            {game.summary.shootout?.length > 0 && (
                <PeriodContainer>
                    <GoalsByPeriod
                        game={game}
                        scoring={game.summary?.scoring?.[game.maxPeriods - 1]}
                        shootoutAttempts={game.summary.shootout}
                        isLarge={isLarge}
                        isWebView={searchParams.has('wv') && searchParams.get('wv') === 'true'}
                    />
                </PeriodContainer>
            )}
        </ScoringSummaryContainer>
    ) : null;
};

export default ScoringSummary;
